import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { CountUpModule } from 'ngx-countup';
import { NumberFormatPipe } from './modules/pipe/number-format.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MainDashboardComponent } from './components/main-dashboard/main-dashboard.component';
import { RegistrationDashboardComponent } from './components/registration-dashboard/registration-dashboard.component';
import { VaccinationDashboardComponent } from './components/vaccination-dashboard/vaccination-dashboard.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { SharedModule } from './modules/shared/shared.module';
import { I18nModule } from './modules/i18n/i18n.module';
import { NewMainDashboardComponent } from './components/new-main-dashboard/new-main-dashboard.component';
import { HeatmapBubbleComponent } from './components/heatmap-bubble/heatmap-bubble.component';



@NgModule({
  declarations: [
    AppComponent,
    NumberFormatPipe,
    MainDashboardComponent,
    RegistrationDashboardComponent,
    VaccinationDashboardComponent,
    NewMainDashboardComponent,
    HeatmapBubbleComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CountUpModule,
    SharedModule,
    I18nModule,
    BrowserAnimationsModule,
    TooltipModule.forRoot(),
    TabsModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
